import { object, string } from 'yup';

export const schema = object().shape({
  text: string().trim().required(),
});
